import React from 'react';

interface GuestModalHeaderProps {
  isEditMode: boolean;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  onFirstNameChange: (value: string) => void;
  onLastNameChange: (value: string) => void;
  onPhoneNumberChange: (value: string) => void;
  onClose: () => void;
}

const GuestModalHeader: React.FC<GuestModalHeaderProps> = ({
  isEditMode,
  firstName,
  lastName,
  phoneNumber,
  onFirstNameChange,
  onLastNameChange,
  onPhoneNumberChange,
  onClose,
}) => {
  return (
    <div className="modal-header">
      {isEditMode ? (
        <div className="modal-edit-form">
          <input
            type="text"
            value={firstName}
            onChange={(e) => onFirstNameChange(e.target.value)}
            placeholder="Prénom"
            className="modal-input"
            autoFocus
          />
          <input
            type="text"
            value={lastName}
            onChange={(e) => onLastNameChange(e.target.value)}
            placeholder="Nom"
            className="modal-input"
          />
        </div>
      ) : (
        <h2>Ajouter un invité</h2>
      )}
      <button className="modal-close" onClick={onClose}>
        ✕
      </button>
    </div>
  );
};

export default GuestModalHeader;
